import { Image, Segment } from "semantic-ui-react"

const DerinOge = (props) => {
    return (
        <div className="eggshell">
            <h2>Derin &Ouml;ge</h2>
            <Image src="/images/people/derinoge.jpg" size="small" floated="left"/>
            <p>
            Born in Istanbul, residing in Brooklyn, Derin &Ouml;ge brings a worldly and eclectic view to the music that she plays. With a classical and contemporary training, she is at home on the concert stage and in the club. Ms. &Ouml;ge was trained at Mimar Sinan University, and holds a masters degree from Purchase Conservatory under the tutelage of Paul Ostrovsky, where she later served on piano faculty. She has played extensively with Piano Music Trio, a chamber ensemble that performs arrangements of Impressionist and Romantic songs for trumpet, piano and cello. Derin &Ouml;ge is also a founding member of Occasional Noise Trio with William Lang, trombone and Cesare Papetti, percussion.
            </p>
            <p>
            Ms. &Ouml;ge has played internationally and locally at such venues as Cornelia Street Caf&eacute;, Mozarteum University, Peter de Grote Festival, The Stone, Flushing Town Hall, Barbes, the Roerich Museum and Symphony Space, among others. In addition, her performance of Mozart’s Sonata in B flat Major has been recorded for the European Broadcast Union.
            </p>
            <p>
            Derin &Ouml;ge’s recent recordings are distributed by System Dialing Records.
            </p>
        </div>
    )
}
export default DerinOge